// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const dormantEntrySchema = z.object({
  "tenant_id": z.string().uuid(),
  "user_id": z.string().uuid(),
  "user_email": z.string(),
  "user_display_name": z.string(),
  "user_status": z.string(),
  "application_id": z.string().uuid(),
  "application_name": z.string(),
  "application_logo": z.string().optional(),
  "grant_source": z.enum(["direct", "group", "both"]),
  "group_id": z.string().uuid().optional(),
  "group_name": z.string().optional(),
  "group_count": z.number().int().min(0),
  "granted_at": z.string().datetime({ offset: true }),
  "last_used_at": z.string().datetime({ offset: true }).optional(),
  "days_idle": z.number().int().min(0),
  "use_count": z.number().int().min(0),
  "severity": z.enum(["fresh", "watch", "stale", "critical"])
});

export const hygieneSummarySchema = z.object({
  "total_entitlements": z.number().int().min(0),
  "fresh_count": z.number().int().min(0),
  "watch_count": z.number().int().min(0),
  "stale_count": z.number().int().min(0),
  "critical_count": z.number().int().min(0),
  "never_used_count": z.number().int().min(0),
  "unique_users": z.number().int().min(0),
  "unique_applications": z.number().int().min(0),
  "hygiene_score": z.number().int().min(0).max(100),
  "oldest_refreshed_at": z.string().datetime({ offset: true }),
  "generated_at": z.string().datetime({ offset: true })
});

export const dormantListSchema = z.object({
  "data": z.array(dormantEntrySchema),
  "pagination": z.object({
    "total": z.number().int().min(0),
    "offset": z.number().int().min(0),
    "limit": z.number().int().min(1).max(500)
  }),
  "summary": hygieneSummarySchema
});

export const policyProposalSchema = z.object({
  "id": z.string().uuid(),
  "auto_revoke_enabled": z.boolean(),
  "threshold_days": z.number().int().min(14).max(730),
  "warn_days_before": z.number().int().min(0).max(30),
  "max_revokes_per_tick": z.number().int().min(1).max(1000),
  "requires_co_approval": z.boolean(),
  "proposed_by": z.string().uuid(),
  "proposed_at": z.string().datetime({ offset: true }),
  "expires_at": z.string().datetime({ offset: true }),
  "status": z.enum(["pending", "approved", "rejected", "superseded"]),
  "decided_by": z.string().uuid().optional(),
  "decided_at": z.string().datetime({ offset: true }).optional()
});

export const policySchema = z.object({
  "tenant_id": z.string().uuid(),
  "auto_revoke_enabled": z.boolean(),
  "threshold_days": z.number().int().min(14).max(730),
  "warn_days_before": z.number().int().min(0).max(30),
  "max_revokes_per_tick": z.number().int().min(1).max(1000),
  "requires_co_approval": z.boolean(),
  "updated_at": z.string().datetime({ offset: true }).optional(),
  "updated_by": z.string().uuid().optional(),
  "co_approved_by": z.string().uuid().optional(),
  "co_approved_at": z.string().datetime({ offset: true }).optional(),
  "approved_proposal_id": z.string().uuid().optional(),
  "pending_proposal": policyProposalSchema.optional()
});

export const revokeLogEntrySchema = z.object({
  "id": z.string().uuid(),
  "user_id": z.string().uuid(),
  "user_email": z.string(),
  "application_id": z.string().uuid(),
  "application_name": z.string(),
  "grant_source": z.string(),
  "group_name": z.string().optional(),
  "threshold_days": z.number().int(),
  "days_idle_at_revoke": z.number().int(),
  "warned_at": z.string().datetime({ offset: true }).optional(),
  "revoked_at": z.string().datetime({ offset: true }),
  "re_granted_at": z.string().datetime({ offset: true }).optional()
});

export const revokeLogListSchema = z.object({
  "data": z.array(revokeLogEntrySchema)
});
